import React, { useState } from "react";
import { Routes, Route, Link, useParams } from "react-router-dom";
import "./blog.css";
import Header from './Header';
import Footer from './Footer';
const blogsData = [
  {
    id: 1,
    title: "Modern Real Estate Design",
    description:
      "Discover how modern real estate design is transforming urban living spaces.",
    content:
      "Full article content for Modern Real Estate Design. Learn about architecture trends, interior innovations, and how technology is redefining luxury living. We explore innovative design ideas and sustainability concepts that shape the next generation of housing.",
    image: "gallery11.jpg",
  },
  {
    id: 2,
    title: "Sustainable Living Ideas",
    description:
      "Explore eco-friendly homes and how they are changing our lifestyle.",
    content:
      "Sustainable living is about reducing environmental impact. From green roofs to energy-efficient systems, we highlight inspiring projects worldwide and how you can adopt similar practices.",
    image: "gallery11.jpg",
  },
  {
    id: 3,
    title: "Luxury Interiors on a Budget",
    description:
      "Tips and tricks to make your home look luxurious without breaking the bank.",
    content:
      "Luxury interiors don’t always need a luxury budget. Learn how to use lighting, textures, and minimalism to transform any space affordably.",
    image: "gallery11.jpg",
  },
  {
    id: 4,
    title: "Smart Homes and IoT",
    description:
      "A look into how IoT is reshaping real estate and modern living.",
    content:
      "Smart home devices are no longer luxury — they’re essential. From voice-controlled systems to intelligent energy management, technology is creating smarter, safer homes.",
    image: "gallery11.jpg",
  },
  {
    id: 5,
    title: "Minimalist Architecture Trends",
    description:
      "How simplicity is becoming the new face of modern architecture.",
    content:
      "Minimalism emphasizes function and simplicity. Learn how architects are combining aesthetics with practicality to create timeless spaces.",
    image: "gallery11.jpg",
  },
  {
    id: 6,
    title: "Urban Planning for the Future",
    description:
      "The role of sustainable cities in the 21st century.",
    content:
      "Urban planning is focusing on sustainability, walkability, and smart transportation. Discover how future cities will evolve.",
    image: "gallery11.jpg",
  },
    {
    id: 7,
    title: "Urban Planning for the Future",
    description:
      "The role of sustainable cities in the 21st century.",
    content:
      "Urban planning is focusing on sustainability, walkability, and smart transportation. Discover how future cities will evolve.",
    image: "gallery11.jpg",
  },
];

const BlogCard = ({ blog }) => {
    const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  return (
    
    <div className="blog-card">
      <img src={`${IMAGE_BASE_URL}/${blog.image}`} alt={blog.title} className="blog-image" />
      <h3>{blog.title}</h3>
      <p>{blog.description}</p>
      <Link to={`/blog/${blog.id}`} className="read-more-btn">
        Read More →
      </Link>
    </div>
  );
};

const BlogList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogsData.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(blogsData.length / blogsPerPage);

  return (
   <>
     <Header />
  

    <div className="container blog-container">
      <h1 className="blog-heading">Our Latest Blogs</h1>
      <div className="blog-list">
        {currentBlogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
    <Footer />
     </>
  );
};

const BlogDetail = () => {
    const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const { id } = useParams();
  const blog = blogsData.find((b) => b.id === parseInt(id));

  if (!blog) return <h2>Blog not found!</h2>;

  return (
    <div className="blog-detail">
      <img  src={`${IMAGE_BASE_URL}/${blog.image}`} alt={blog.title} className="detail-image" />
      <h2>{blog.title}</h2>
      <p>{blog.content}</p>
      <Link to="/" className="back-btn">← Back to Blogs</Link>
    </div>
  );
};

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<BlogList />} />
      <Route path="/blog/:id" element={<BlogDetail />} />
    </Routes>
  );
};

export default App;
